var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-image",style:({ borderRadius: _vm.borderRadius })},[_c('transition',{attrs:{"name":"fade"}},[_c('div',{style:({
        backgroundImage: ("url(" + _vm.src + ")"),
      }),on:{"click":_vm.handlePreview}})]),_c('div',{staticClass:"placeholder"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }